import React from 'react';
import ConventionsPage from './ConventionsPage';

export default function CmcCipascopPage() {
  return (
    <ConventionsPage
      contractType="CIPASCOP"
      defaultTitle="Convention cadre C.I.P.A.S.C.O.P"
      headerTitle="Convention cadre C.I.P.A.S.C.O.P"
      subtitle="Convention individuelle entre l'organisme et le coopérateur (C.I.P.A.S.C.O.P)"
      testIdRoot="cipascop"
    />
  );
}
